/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { AppContainer } from 'react-hot-loader';
import ReactDOM from 'react-dom';
import Redbox from 'redbox-react';
import {
  browserHistory,
  hashHistory,
} from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { IEVer } from './utils/IEUtils';
import configureStore from './redux/store/configureStore';
import Root from './containers/Root';

import './polyfill';

let history = browserHistory;
const iev = IEVer();
if (iev === 8 || iev === 9) {
  // fallback to hashHistory for old version IE
  history = hashHistory;
}

const store = configureStore(history, {});
window._store = store;

history = syncHistoryWithStore(history, store);

const render = () => {
  ReactDOM.render(
    <AppContainer errorReporter={Redbox}>
      <Root history={history} store={store} />
    </AppContainer>,
    document.getElementById('root'));
};

render();

if (module.hot) {
  module.hot.accept('./containers/Root', () => {
    render();
  });
}




// WEBPACK FOOTER //
// ./src/index.jsx